// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"WebfitLoadingSpinner_loadingSpinner__4D9Y-","iconSpin":"WebfitLoadingSpinner_iconSpin__Ulg6U","spin":"WebfitLoadingSpinner_spin__jOK2y"};